import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-address-thanks',
  templateUrl: './address-thanks.component.html',
  styleUrls: ['./address-thanks.component.scss'],
})
export class AddressThanksComponent implements OnInit {
  orderId="";
  currentDate = new Date().toLocaleDateString();
  deliveryDate = new Date(new Date().getFullYear(),(new Date().getMonth()),(new Date().getDate()+5)).toLocaleDateString();
  constructor(private router:Router,private modalController:ModalController,public navParams: NavParams) { 
    console.log("this.orderId",navParams.data.orderID);
    this.orderId = navParams.data.orderID;
    
  }

  ngOnInit() {}

  close() {
  
      this.modalController.dismiss();
    }

    viewOrder(){
      this.modalController.dismiss();
      this.router.navigate(['view-order']);
    }
    help(){
      this.modalController.dismiss();
     // this.router.navigate(['view-order']);
    }
}
